import { AGWASuiteApiClientBase, ApiResponse } from '../agwasuite-api';
import type { SessionHealthResponse } from '../agwa-api-model';

/**
 * Client for the sign-in check, `GET /api/SessionHealth` (D-137, @CONN-HEALTH-007).
 *
 * Its own client rather than a method on `ApiLogin`, for the same reason `ApiTabSession` is: it is
 * not a login, and nothing here signs anybody in or renews anything. The server answers who the
 * request's selected account is, never with a token, and without extending the sign-in.
 */
export class ApiSessionHealth extends AGWASuiteApiClientBase {
  /**
   * Who this tab is signed in as, or a 401/403 when the sign-in has ended.
   *
   * No retries and a 5 second limit: the connection-health monitor asks this on its own schedule
   * and decides from one answer, so a retry loop inside the client would only delay the decision
   * (and hold the page on a stale state) while the monitor is already going to ask again.
   *
   * Not reported as unanswered (D-144): this request is the monitor's own check, and the monitor
   * already reads an unusable answer here as a reason to ask whether the server is reachable.
   */
  async check(): Promise<ApiResponse<SessionHealthResponse>> {
    return this.request<SessionHealthResponse>(
      'GET',
      '/api/SessionHealth',
      undefined,
      { retry: false, timeoutMs: 5_000, reportUnanswered: false }
    );
  }
}
